import ParameterFieldBase from '../../../_common/platform/ts/ParameterFieldBase';
import { default as EditComponent, ISelectMultiFieldOptions } from '../../../_common/application/tsx/SelectMultiField';

export class SelectMultiField extends ParameterFieldBase<ISelectMultiFieldOptions> {
    public static defaultValidators = [];

    public static EditComponent = EditComponent;

    public static getDefaultValue() {
        return [];
    }

    constructor(glob, title: string, validators?: any, defaultVal?: any, options?: ISelectMultiFieldOptions) {
        super(glob, title, SelectMultiField.defaultValidators, validators, defaultVal, options);
    }
}
